<template>
    <div>
        <!-- 录入投诉案件 弹窗 -->
        <el-dialog title="录入投诉案件" :visible.sync="dialogEnterFlag" center :modal-append-to-body="false" :close-on-click-modal="false" width="900px" top="5vh" @close="closeDiag">
            <div class="dialog_content">
                <el-form :model="addCaseForm" :rules="rules" ref="ruleForm" label-width="110px">
                    <div class="form_content">
                        <el-row>
                            <el-col class="title_col" :span="8">
                                <el-form-item label="投诉编号：" prop="complaintNumber">
                                    <el-input v-model.trim="addCaseForm.complaintNumber" maxlength="50" :class="{ errorBorder: complaintNumberError }"></el-input>
                                    <div class="el-form-item__error" v-if="complaintNumberError">投诉编号已存在</div>
                                </el-form-item>
                            </el-col>
                            <el-col class="title_col" :span="8">
                                <el-form-item label="保单号：" prop="policyNo">
                                    <el-input v-model.trim="addCaseForm.policyNo" maxlength="50"></el-input>
                                    <div class="warning-message" v-if="policyNoError">{{ policyNoError }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col class="title_col" :span="8">
                                <el-form-item label="案件号：" prop="caseNo">
                                    <el-input v-model.trim="addCaseForm.caseNo" maxlength="50"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col class="title_col" :span="8">
                                <el-form-item label="投诉人：" prop="complaintPerson">
                                    <el-input v-model.trim="addCaseForm.complaintPerson"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col class="title_col" :span="8">
                                <el-form-item label="投诉人身份：" prop="complaintIdCard">
                                    <!-- <el-input v-model.trim="addCaseForm.complaintIdCard" maxlength="11"></el-input> -->
                                    <el-select v-model="addCaseForm.complaintIdCard" clearable placeholder="请选择">
                                        <el-option v-for="item in complaintIdCardOptions" :key="item.id" :label="item.dictName" :value="item.dictName"> </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <!-- oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(\d)/, '$1')" -->
                            <el-col class="title_col" :span="8">
                                <el-form-item label="投诉电话1：" prop="complaintPhone">
                                    <el-input v-model="addCaseForm.complaintPhone" maxlength="11" oninput="value=value.replace(/\D/g, '')"></el-input>
                                    <div class="warning-message" v-if="complaintPhoneError">{{ complaintPhoneError }}</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="addCaseForm.complaintIdCard == '其他'">
                            <el-col class="title_col" :span="8" :offset="8">
                                <el-form-item label="身份备注：" prop="complaintIdCardRemark">
                                    <el-input v-model="addCaseForm.complaintIdCardRemark" maxlength="20"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col class="title_col" :span="8">
                                <el-form-item label="投诉原因：" prop="complaintCause">
                                    <el-select v-model="addCaseForm.complaintCause" filterable clearable placeholder="请选择" @change="causeChange">
                                        <el-option v-for="item in reasonOptions" :key="item.id" :label="item.dictName" :value="item.dictName"> </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col class="title_col" :span="8">
                                <el-form-item label="具体争议：" prop="specificDisputes">
                                    <el-select v-model="addCaseForm.specificDisputes" :disabled="!addCaseForm.complaintCause" filterable clearable placeholder="请选择">
                                        <el-option v-for="item in disputesOptions" :key="item.id" :label="item.dictName" :value="item.dictName"> </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col class="title_col" :span="8">
                                <el-form-item label="投诉电话2：" prop="complaintPhone2">
                                    <el-input ref="addCasePhone2" v-model="addCaseForm.complaintPhone2" maxlength="11" oninput="value=value.replace(/\D/g, '')" @blur="replaceNegate = false"></el-input>
                                    <div class="warning-message" v-if="complaintPhoneError2">{{ complaintPhoneError2 }}</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col class="title_col" :span="8">
                                <el-form-item label="受理渠道：" prop="complaintChannel">
                                    <el-select v-model="addCaseForm.complaintChannel" filterable clearable placeholder="请选择" @change="channelChange">
                                        <el-option v-for="item in channelOptions" :key="item.id" :label="item.dictName" :value="item.dictName"> </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col class="title_col" :span="8">
                                <el-form-item label="登记日期：" prop="recordDay">
                                    <el-date-picker v-model="addCaseForm.recordDay" placeholder="请选择日期" clearable type="date" value-format="yyyy-MM-dd" style="width: 100%"> </el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col class="title_col" :span="8">
                                <el-form-item label="骑手姓名：" prop="riderName">
                                    <el-input v-model.trim="addCaseForm.riderName" maxlength="30"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col class="title_col" :span="8">
                                <el-form-item label="骑手身份证：" prop="riderIdCard">
                                    <el-input v-model.trim="addCaseForm.riderIdCard" maxlength="20"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col class="title_col" :span="24">
                                <el-form-item label="投诉内容：" prop="complaintContent">
                                    <el-input class="textareaNumPosition" v-model="addCaseForm.complaintContent" type="textarea" :autosize="{ minRows: 2 }" maxlength="1000" show-word-limit placeholder="请输入内容"> </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col class="title_col" :span="8">
                                <el-form-item label="责任人：" prop="liablePerson">
                                    <el-select v-model="addCaseForm.liablePerson" placeholder="请选择" filterable clearable @change="personChange">
                                        <el-option v-for="item in complaintCaseUserOptions" :key="item.userId" :label="item.nickName" :value="item.nickName + '$' + item.deptId + '$' + item.userName"> </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col class="title_col" :span="8">
                                <el-form-item label="涉诉机构：" prop="complaintOrganization">
                                    {{ addCaseForm.complaintOrganization ? addCaseForm.complaintOrganization : '--' }}
                                </el-form-item>
                            </el-col>
                            <el-col class="title_col" :span="8">
                                <el-form-item label="责任机构：" prop="liableOrganization">
                                    <el-select v-model="addCaseForm.liableOrganization" placeholder="请选择" filterable clearable>
                                        <el-option v-for="item in institutionOptions" :key="item.id" :label="item.dictName" :value="item.dictName"> </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col class="title_col" :span="8">
                                <el-form-item label="处理人：" prop="liablePerson">
                                    <!-- <el-select v-model="addCaseForm.assistingHandler" placeholder="请选择" filterable clearable>
                                        <el-option v-for="item in handlerUserOptions" :key="item.id" :label="item.dictName" :value="item.dictName"> </el-option>
                                    </el-select> -->
                                    <el-select v-model="addCaseForm.assistingHandlerUser" placeholder="请选择" filterable clearable @change="assistingChange">
                                        <!-- <el-option v-for="item in complaintCaseUserOptions" :key="item.userId" :label="item.nickName" :value="item.nickName + '$' + item.deptId + '$' + item.userName"> </el-option> -->
                                        <el-option v-for="item in complaintCaseUserOptions" :key="item.userId" :label="item.nickName" :value="item.userName"> </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col class="title_col" :span="8">
                                <el-form-item label="涉诉省：" prop="">
                                    <el-select v-model="addCaseForm.province" filterable clearable placeholder="请选择" @change="enterProvinceChange">
                                        <el-option v-for="item in provinceOptions" :key="item.areaCode" :label="item.areaName" :value="item.areaName"> </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col class="title_col" :span="8">
                                <el-form-item label="涉诉市：" prop="province">
                                    <el-select v-model="addCaseForm.city" filterable clearable placeholder="请选择">
                                        <el-option v-for="item in cityOptions" :key="item.areaCode" :label="item.areaName" :value="item.areaName"> </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col class="title_col" :span="8">
                                <el-form-item label="升级情况：" prop="upgradeSituation">
                                    <el-select v-model="addCaseForm.upgradeSituation" filterable clearable placeholder="请选择">
                                        <el-option v-for="(item, index) in upgradeOptions" :key="index" :label="item.dictName" :value="item.dictName"> </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col class="title_col" :span="24">
                                <el-form-item label="备注：" prop="remark">
                                    <el-input class="textareaNumPosition" v-model="addCaseForm.remark" type="textarea" :autosize="{ minRows: 4 }" maxlength="255" show-word-limit placeholder="请输入内容"> </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="phoneTable">
                        <el-row>
                            <el-col class="title_col" :span="8"> 投诉电话统计： </el-col>
                        </el-row>
                        <el-table ref="phoneTableRef" :data="phoneComplaintList" style="width: 100%" max-height="230">
                            <el-table-column label="序号" width="45">
                                <template slot-scope="scope"> {{ scope.$index + 1 }}</template>
                            </el-table-column>
                            <el-table-column prop="complaintPhone" label="投诉电话1" width="110"> </el-table-column>
                            <el-table-column prop="complaintPhone2" label="投诉电话2" width="110"> </el-table-column>
                            <el-table-column prop="complaintNumber" label="投诉编号"> </el-table-column>
                            <el-table-column prop="policyNo" label="保单号"> </el-table-column>
                            <el-table-column prop="remark" label="备注" width="180">
                                <template slot-scope="scope">
                                    <overflow-txt :txt="scope.row.remark ? scope.row.remark : ''"></overflow-txt>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="temporaryCase">暂 存</el-button>
                <el-button type="primary" @click="enterCase(true)">创 建</el-button>
                <el-button @click="enterCase(false)">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import OSS from 'ali-oss';
import { v4 as uuidv4 } from 'uuid';

let queryCaseRuleFlag = false;
const validatePass = (rule, value, callback) => {
    if (value.length > 0 && queryCaseRuleFlag) {
        callback(new Error('未查询到案件号，请输入正确的理赔报案号重新查询'));
    } else {
        callback();
    }
};
export default {
    props: {
        dialogShow: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            createdFlag: false,
            replaceNegate: true,
            baseURL: '',
            dialogEnterFlag: false,
            creatCaseFlag: false,
            currentFileIndex: -1,
            policyNoError: '',
            complaintNumberError: '',
            complaintPhoneError: '',
            complaintPhoneError2: '',
            addCaseForm: {
                complaintNumber: '',
                complaintChannel: '',
                policyNo: '',
                caseNo: '',
                complaintPerson: '',
                complaintIdCard: '',
                complaintIdCardRemark: '',
                complaintPhone: '',
                complaintPhone2: '',
                complaintContent: '',
                complaintCause: '',
                specificDisputes: null,
                recordDay: new Date().toISOString().split('T')[0],
                complaintOrganization: '',
                liablePerson: '',
                assistingHandler: '',
                assistingHandlerUser: '',
                checkIndemnityPerson: '',
                province: '',
                city: '',
                upgradeSituation: '未升级',
                closeCaseFlag: '',
                remark: '',
                riderName: '',
                riderIdCard: ''
            },
            channelOptions: [],
            reasonOptions: [],
            disputesOptions: [],
            complaintIdCardOptions: [],
            booleanOptions: [
                {
                    label: '是',
                    code: true
                },
                {
                    label: '否',
                    code: false
                }
            ],
            province: '',
            provinceOptions: [],
            city: '',
            cityOptions: [],
            district: '',
            districtOptions: [],
            cityDisabled: true,
            districtDisabled: true,
            causeOptions: [],
            productTypeOptions: [],
            insureTypeOptions: [],
            allocationUserOptions: [],
            allocationUserObj: {},
            caseFileTypeOptions: [],
            caseFileTypeObj: {},
            fileTypeList: ['tiff', 'jfif', 'bmp', 'webp', 'gif', 'svg', 'jpg', 'svgz', 'png', 'jpeg', 'ico', 'xbm', 'dib', 'pjp', 'apng', 'tif', 'pjpeg', 'avif'],
            num: 0,
            checkPhoneApi: true,
            upgradeOptions: [],
            handlerUserOptions: [],
            provinceObj: {},
            cityOptions: [],
            complaintCaseUserOptions: [],
            complaintCaseUserObj: {},
            sysDeptObj: {},
            sysDept: [],
            institutionOptions: [],
            coverPolicyNoFlag: true,
            coverPhone1Flag: true,
            phoneComplaintList: [],
            tableDom: null
        };
    },
    mounted() {
        this.baseURL = this.$store.getters.baseURL;

        this.$nextTick(() => {
            this.tableDom = this.$refs.phoneTableRef.bodyWrapper;
            this.tableDom.addEventListener('scroll', () => {
                let list = document.getElementsByClassName('el-tooltip__popper');
                if (list.length > 0) {
                    list[list.length - 1].style.display = 'none';
                }
            });
        });

        this.queryTemporary();
        // 获取渠道
        this.getPublicEnum('COMPLAINT_CHANNEL_INFO', 'channelOptions');
        // 获取投诉原因
        this.getPublicEnum('COMPLAINT_CAUSE_TYPE', 'reasonOptions');
        // 获取升级情况
        this.getPublicEnum('COMPLAINT_UPGRADE_SITUATION', 'upgradeOptions');
        // 协助处理人
        this.getPublicEnum('COMPLAINT_ASSISTING_HANDLER', 'handlerUserOptions');
        // 责任机构
        this.getPublicEnum('COMPLAINT_LIABLE_PERSON', 'institutionOptions');
        // 投诉人身份
        this.getPublicEnum('COMPLAINT_ID_CARD', 'complaintIdCardOptions');
        // 查询省市
        this.findProvince();
        // 部门
        this.findSysDept();
        // 责任人
        this.getComplaintCaseUser();
    },
    computed: {
        // 自定义表单规则
        rules() {
            let complaintNumberRules = [
                { validator: this.complaintNumberValidator, trigger: ['blur'] },
                { required: true, message: '请输入', trigger: ['blur'] }
            ];

            let phoneRules = [
                { validator: this.phoneNoValidator, trigger: ['blur'] },
                { required: true, message: '请输入', trigger: ['blur'] },
                { min: 11, max: 11, message: '电话长度为11位', trigger: ['blur'] }
            ];

            let phoneRules2 = [
                { validator: this.phoneNoValidator, trigger: ['blur'] },
                { message: '请输入', trigger: ['blur'] },
                { min: 11, max: 11, message: '电话长度为11位', trigger: ['blur'] }
            ];

            let policyNoRules = [
                { validator: this.policyNoValidator, trigger: ['blur'] },
                { message: '请输入', trigger: ['blur'] }
                // {
                //     pattern: /^[A-Za-z0-9]*$/, // 正则：只允许字母和数字
                //     message: '仅支持输入字母和数字',
                //     trigger: ['blur', 'change'] // 失焦和输入变化时都校验
                // }
            ];

            if (!this.checkPhoneApi) {
                phoneRules = [
                    { required: true, message: '请输入', trigger: ['blur'] },
                    { min: 11, max: 11, message: '电话长度为11位', trigger: ['blur'] }
                ];

                policyNoRules = [
                    { message: '请输入', trigger: ['blur'] }
                    // {
                    //     pattern: /^[A-Za-z0-9]*$/, // 正则：只允许字母和数字
                    //     message: '仅支持输入字母和数字',
                    //     trigger: ['blur', 'change'] // 失焦和输入变化时都校验
                    // }
                ];
            }

            return {
                complaintNumber: complaintNumberRules,
                complaintChannel: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
                complaintPerson: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
                complaintIdCard: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
                complaintPhone: phoneRules,
                complaintPhone2: phoneRules2,
                complaintContent: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
                complaintCause: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
                recordDay: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
                // complaintOrganization: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
                // liablePerson: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
                checkIndemnityPerson: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
                // province: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
                // upgradeSituation: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
                closeCaseFlag: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
                policyNo: policyNoRules,
                riderName: [
                    { required: false, message: '请输入骑手姓名', trigger: 'blur' },
                    {
                        pattern: /^[\u4e00-\u9fa5a-zA-Z]+([·\u00A0-\uFFFF\u0020-\u002F\u003A-\u0040\u005B-\u0060\u007B-\u007E]*[\u4e00-\u9fa5a-zA-Z]+)*$/, // 正则：中英文符号只能在文字中间
                        message: '仅支持输入中文、英文，且符号只能在中间',
                        trigger: ['blur', 'change'] // 失焦和输入变化时都校验
                    }
                ],
                riderIdCard: [
                    { required: false, message: '请输入骑手身份证号', trigger: 'blur' },
                    {
                        pattern: /(^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$)|(^[1-9]\d{5}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}$)/,
                        message: '请输入正确的身份证号',
                        trigger: ['blur', 'change']
                    }
                ]
            };
        }
    },
    methods: {
        causeChange(val) {
            if (val) {
                this.getExpandInfo(val);
            } else {
                this.addCaseForm.specificDisputes = null;
            }
        },
        getExpandInfo(infoStr) {
            this.instance.post('/backstage/getDict', { dictType: 'COMPLAINT_CAUSE_SUB_TYPE', expandInfo: infoStr }).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    this.disputesOptions = data.data;
                }
            });
        },
        findSysDept() {
            this.instance.post('/complaintInfo/findSysDept ', {}).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    this.sysDept = data.data;
                    data.data &&
                        data.data.forEach((item) => {
                            this.sysDeptObj[item.deptId] = item.deptName;
                        });
                }
            });
        },
        getComplaintCaseUser() {
            this.instance.post('/complaintInfo/distributeComplaintCaseUser', {}).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    this.complaintCaseUserOptions = data.data;
                    this.complaintCaseUserOptions.forEach((item) => {
                        this.complaintCaseUserObj[item.userName] = item.nickName;
                    });
                }
            });
        },
        personChange(val) {
            if (!val) {
                this.addCaseForm.complaintOrganization = '';
                this.addCaseForm.liablePersonUser = '';
                this.addCaseForm.liablePerson = '';
                return;
            }

            let valArr = val.split('$');

            if (valArr.length < 2) {
                this.addCaseForm.complaintOrganization = '';
                this.addCaseForm.liablePersonUser = '';
                this.addCaseForm.liablePerson = valArr[0];
                return;
            }
            this.addCaseForm.liablePerson = valArr[0];
            this.addCaseForm.complaintOrganization = this.sysDeptObj[valArr[1]];
            this.addCaseForm.liablePersonUser = valArr[2];
        },
        assistingChange(val) {
            if (val) {
                this.addCaseForm.assistingHandler = this.complaintCaseUserObj[val];
            } else {
                this.addCaseForm.assistingHandler = null;
            }
        },
        findProvince() {
            this.instance.post('/area/findProvince', {}).then((res) => {
                let data = res.data;
                if (data.code == 1 && data.data) {
                    this.provinceOptions = data.data;
                    this.provinceObj = {};
                    data.data.forEach((item) => {
                        this.provinceObj[item.areaName] = item.areaCode;
                    });
                }
            });
        },
        findCity() {
            let code = this.addCaseForm.province.split('-')[1];
            this.instance.post('/area/findCity/' + code, {}).then((res) => {
                let data = res.data;
                if (data.code == 1 && data.data) {
                    this.cityDisabled = false;
                    this.districtDisabled = false;
                    this.cityOptions = data.data;
                }
            });
        },
        findDistrict() {
            let code = this.addCaseForm.city.split('-')[1];
            this.instance.post('/area/findDistrict/' + code, {}).then((res) => {
                let data = res.data;
                if (data.code == 1 && data.data) {
                    this.districtDisabled = false;
                    this.districtOptions = data.data;
                }
            });
        },
        provinceChange1(val) {
            this.addCaseForm.city = '';
            this.addCaseForm.district = '';
            this.cityDisabled = true;
            this.districtDisabled = true;
            if (val) {
                this.findCity();
            }
        },
        provinceChange2(val) {
            this.addCaseForm.district = '';
            this.districtDisabled = true;
            if (val) {
                this.findDistrict();
            }
        },
        currentData(currentItem, currentIndex) {
            this.currentFileIndex = currentIndex;
        },
        getCaseFileType() {
            this.instance.get('/lawsuitCase/material/getCaseFileType', { params: {} }).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    this.caseFileTypeObj = {};
                    this.caseFileTypeOptions = data.data;
                    data.data.forEach((item) => {
                        this.caseFileTypeObj[item.code] = item.name;
                    });
                }
            });
        },
        getCause() {
            this.instance.get('/lawsuitCase/getCause', { params: {} }).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    this.causeOptions = data.data;
                }
            });
        },
        getProductType() {
            this.instance.get('/lawsuitCase/getProductType', { params: {} }).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    this.productTypeOptions = data.data;
                }
            });
        },
        getInsureTypeOptions() {
            this.instance.get('/lawsuitCase/getInsureTypeName', { params: {} }).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    this.insureTypeOptions = data.data;
                }
            });
        },
        allocationUserChange(val) {
            this.addCaseForm.distributeHandler = this.allocationUserObj[val] || '';
        },
        enterCase(submitFlag) {
            this.createdFlag = true;
            if (submitFlag) {
                this.checkPhoneApi = false;
                let addCaseData = JSON.parse(JSON.stringify(this.addCaseForm));

                setTimeout(() => {
                    this.$nextTick(() => {
                        this.$refs.ruleForm.validate((valid) => {
                            valid && !this.complaintNumberError && this.addNewCase(addCaseData);
                        });
                    });
                }, 200);
                setTimeout(() => {
                    this.createdFlag = false;
                }, 2000);
            } else {
                this.closeDiag();
            }
        },
        // 暂存案件信息
        temporaryCase() {
            this.instance.post('/complaintInfo/temporaryStorageComplaint', this.addCaseForm).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    this.$message.success('暂存成功！');
                } else {
                    this.$message.error(data.message);
                }
            });
        },
        // 获取暂存信息
        queryTemporary() {
            this.instance.post('/complaintInfo/findTemporaryStorageInfo', {}).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    if (data.data) {
                        this.addCaseForm = data.data;
                        this.addCaseForm.complaintCause && this.causeChange(this.addCaseForm.complaintCause);
                    }
                } else {
                    this.$message.error('获取暂存信息失败！');
                }
            });
        },
        closeDiag() {
            this.$emit('switchDialog', false);
            this.resetCaseData();
        },
        resetCaseData() {
            this.addCaseForm = {
                complaintNumber: '',
                complaintChannel: '',
                policyNo: '',
                complaintPerson: '',
                complaintIdCard: '',
                complaintIdCardRemark: '',
                complaintPhone: '',
                complaintPhone2: '',
                complaintContent: '',
                complaintCause: '',
                specificDisputes: '',
                recordDay: new Date().toISOString().split('T')[0],
                complaintOrganization: '',
                liablePerson: '',
                checkIndemnityPerson: '',
                province: '',
                city: '',
                upgradeSituation: '未升级',
                closeCaseFlag: '',
                remark: ''
            };
        },
        addNewCase(data) {
            if (this.creatCaseFlag) {
                return;
            }
            this.creatCaseFlag = true;
            this.instance.post('/complaintInfo/addComplaint', data).then((res) => {
                this.creatCaseFlag = false;
                let data = res.data;
                if (data.code == 1) {
                    this.$message.success('录入案件成功！');
                    this.$emit('searchCasePage', true);
                    this.closeDiag();
                } else {
                    this.$message.error(data.message);
                }
            });
        },
        channelChange(val) {
            if (!val) {
                this.addCaseForm.upgradeSituation = '未升级';
                return;
            }

            this.instance.post('/complaintInfo/findExistsComplaint', this.addCaseForm).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    // 升级情况
                    this.addCaseForm.upgradeSituation = data.data.upgradeSituation;
                }
            });
        },
        //自定义的投诉编号校验规则
        complaintNumberValidator(rule, value, callback) {
            if (value) {
                if (this.createdFlag) {
                    callback();
                    return;
                }
                this.instance.post('/complaintInfo/findExistsComplaint', this.addCaseForm).then((res) => {
                    let data = res.data;
                    if (data.code == 1) {
                        let complaintNumberNum = data.data.complaintNumberNum;
                        if (complaintNumberNum > 0) {
                            this.complaintNumberError = '投诉编号已存在';
                            callback();
                        } else {
                            this.complaintNumberError = '';
                            callback();
                        }
                    }
                });
            } else {
                this.policyNoError = '';
                callback();
            }
        },
        //自定义的保单号校验规则
        policyNoValidator(rule, value, callback) {
            if (value) {
                if (this.createdFlag) {
                    callback();
                    return;
                }
                this.instance.post('/complaintInfo/findExistsComplaint', this.addCaseForm).then((res) => {
                    let data = res.data;
                    if (data.code == 1) {
                        this.coverPolicyNoFlag && !this.createdFlag && this.setEnterForm(data.data);
                        let policyNoNum = data.data.policyNoNum;
                        if (policyNoNum > 0) {
                            this.policyNoError = '保单号已存在，数量' + policyNoNum;
                            callback();
                        } else {
                            this.policyNoError = '';
                            callback();
                        }
                    }
                });
            } else {
                this.policyNoError = '';
                callback();
            }
        },
        setEnterForm(formData) {
            if (!formData) {
                return;
            }

            // 涉诉机构
            this.addCaseForm.complaintOrganization = formData.complaintOrganization;
            // 责任人
            this.addCaseForm.liablePerson = formData.sysUserVo ? formData.sysUserVo.nickName : null;
            this.addCaseForm.liablePersonUser = formData.sysUserVo ? formData.sysUserVo.userName : null;
            // 处理人
            this.addCaseForm.assistingHandler = formData.sysUserVo ? formData.sysUserVo.nickName : null;
            this.addCaseForm.assistingHandlerUser = formData.sysUserVo ? formData.sysUserVo.userName : null;
            // 省
            this.addCaseForm.province = formData.accidentProvince;
            // 市
            this.$set(this.addCaseForm, 'city', formData.accidentCity);
            this.coverPolicyNoFlag = false;
        },
        //自定义的电话号校验规则
        phoneNoValidator(rule, value, callback) {
            if (this.createdFlag) {
                callback();
                return;
            }

            if (!value) {
                return;
            }

            let tmpQueryData = JSON.parse(JSON.stringify(this.addCaseForm));
            this.instance.post('/complaintInfo/findExistsComplaint', tmpQueryData).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    let PhoneNoNum = data.data.complaintPhoneNum;
                    let PhoneNoNum2 = data.data.complaintPhone2Num;

                    this.phoneComplaintList = data.data.phoneComplaintList || [];

                    if (this.coverPhone1Flag && data.data.preComplaint && this.replaceNegate && !this.createdFlag) {
                        this.setPreComplaintData(data.data, tmpQueryData);
                    }

                    if (PhoneNoNum2 > 0) {
                        this.complaintPhoneError2 = '手机号已存在，数量' + PhoneNoNum2;
                    } else {
                        this.complaintPhoneError2 = '';
                    }
                    if (PhoneNoNum > 0) {
                        this.complaintPhoneError = '手机号已存在，数量' + PhoneNoNum;
                        callback();
                    } else {
                        this.complaintPhoneError = '';
                        callback();
                    }
                    this.replaceNegate = true;
                }
            });
        },
        setPreComplaintData(preData, checkQueryData) {
            preData = JSON.parse(JSON.stringify(preData));
            let tmpForm = JSON.parse(JSON.stringify(this.addCaseForm));
            this.addCaseForm = preData.preComplaint;
            this.addCaseForm.complaintCause && this.causeChange(this.addCaseForm.complaintCause);

            // 根据省查市
            preData.province && this.findNameCityChange(preData.province);

            // 投诉编号
            this.addCaseForm.complaintNumber = tmpForm.complaintNumber;
            // 受理渠道
            this.addCaseForm.complaintChannel = tmpForm.complaintChannel;
            // 升级情况
            this.addCaseForm.upgradeSituation = tmpForm.upgradeSituation || null;
            // 登记日期
            this.$set(this.addCaseForm, 'recordDay', preData.preComplaint.recordDate);

            // 设置新的升级情况  先输受理渠道，后查询投诉电话1
            if (checkQueryData.complaintChannel && checkQueryData.complaintPhone) {
                this.addCaseForm.upgradeSituation = preData.upgradeSituation || null;
                this.$forceUpdate();
            }

            // 责任人
            let result = this.complaintCaseUserOptions.find((item) => {
                return item.nickName == preData.preComplaint.liablePerson;
            });
            this.addCaseForm.liablePersonUser = result ? result.userName : null;

            // 电话2 校验
            this.$refs.addCasePhone2.focus();
            setTimeout(() => {
                this.$refs.addCasePhone2.blur();
            }, 10);
            this.coverPhone1Flag = false;
        },

        findCityChange() {
            this.cityOptions = [];
            let code = this.provinceObj[this.addCaseForm.province];
            this.instance.post('/area/findCity/' + code, {}).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    this.cityOptions = data.data;
                }
            });
        },
        findNameCityChange(provinceName) {
            this.instance.post('/area/findCityName/' + provinceName, {}).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    this.cityOptions = data.data;
                }
            });
        },
        enterProvinceChange(val) {
            this.addCaseForm.city = '';
            this.findCityChange();
        }
    },
    watch: {
        dialogShow: {
            handler(val) {
                this.dialogEnterFlag = val;
                // val && this.initOSSClient();
            },
            immediate: true
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../assets/css/table_public.css';
// 弹窗
.dialog_content {
    margin-top: -10px;
    .query_case_form {
        /deep/ .form_item {
            .el-form-item__label {
                white-space: nowrap;
                margin-left: -11px;
            }
        }
    }
    .case_show {
        margin-bottom: 20px;
        .title_col {
            .left_col {
                .query_title {
                    width: 138px !important;
                }
            }
        }
    }
    .el-form-item {
        margin-bottom: 0;
    }
    .el-row {
        margin-bottom: 20px;
        .title_col {
            .txt_box {
                display: inline-block;
            }
            .info_title {
                width: 100px;
                text-align: right;
                // border: 1px solid red;
            }
            .query_title {
                width: 128px;
            }
            /deep/ .shengfen {
                .el-form-item__content {
                    margin-left: 0 !important;
                    position: relative;
                }
            }
            .warning-message {
                position: absolute;
                top: 25px;
                color: orange;
                font-size: 12px;
            }
        }
    }
    .el-row:last-child {
        margin-bottom: 0;
    }
    .form_item {
        margin-bottom: 20px;
        .el-row {
            margin-bottom: 0px;
        }
    }
    .exist_case {
        /deep/ .el-input__inner {
            border: 1px solid #e6a23c;
        }
        .exist_col {
            position: relative;
            .exist_message {
                color: #e6a23c;
                font-size: 12px;
                position: absolute;
                bottom: -27px;
            }
        }
    }
    .form_content {
        padding: 0 10px;
    }
    .case_entry {
        margin-bottom: 20px;
    }
    .updateFile {
        position: relative;
        left: -2px;
        .el-col {
            line-height: 28px;
            position: relative;
            .del_btn {
                font-size: 20px;
                cursor: pointer;
            }
            .disabledBtn {
                width: 25px;
                height: 25px;
                position: absolute;
                left: 0;
                top: 0;
                z-index: 2;
                cursor: not-allowed;
            }
            .errorBtn {
                color: red;
            }
            .progressSpan {
                position: absolute;
                top: 0;
                right: -36px;
                color: #409eff;
            }
        }
    }
    .uploadBtn {
        position: relative;
        left: -2px;
    }

    .preview_file {
        position: relative;
        .preview_image {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            /deep/ img {
                opacity: 0 !important;
            }
        }
    }
    // .province_item {
    //     /deep/ .el-form-item__content {
    //         // margin-left: 0 !important;
    //         // margin-left: 5px !important;
    //         .selectProvince {
    //             width: 30%;
    //             margin-right: 27px;
    //         }
    //         .selectProvince:last-child {
    //             margin-right: 0;
    //         }
    //         .el-form-item__error {
    //         }
    //     }
    // }
    .province_box {
        display: flex;
        justify-content: space-between;
        .province_item {
            width: 45%;
        }
        .province_item:nth-child(2) {
            width: 25%;
            margin-left: 0px;
            /deep/ .el-form-item__content {
                margin-left: 0 !important;
            }
        }
        .province_item:nth-child(3) {
            width: 25%;
            margin-left: 0px;
            /deep/ .el-form-item__content {
                margin-left: 0 !important;
            }
        }
    }

    .phoneTable {
        margin-top: 20px;
    }
}
.errorBorder {
    /deep/ .el-input__inner {
        border: 1px solid red;
    }
}

.textareaNumPosition {
    /deep/ .el-input__count,
    .el-input__count,
    /deep/ span {
        background: none !important;
        bottom: -25px !important;
        right: 3px !important;
    }
}
</style>